import { IconSparkles } from '../icons.jsx';
import { useCopilotController } from '../../app/CopilotController.jsx';

// Feature C — "Explain this chart" affordance. Sits in a chart card header
// (sparkle + "Explain", `btn ghost sm`). Clicking opens the PRIME Copilot
// pre-filled with a chart-specific question and a `visual` snapshot of the EXACT
// plotted values, so the grounded answer explains THIS chart from real numbers.
//
// The snapshot is built at click time (via `buildVisual`) from the latest
// plotted arrays, so the copilot always explains what is currently on screen.
// `autoSubmit` is passed straight through to the controller: true (default)
// sends the prefilled question immediately; false populates the input only.
export function ExplainChartButton({
  question,
  buildVisual,
  visual: visualProp = null,
  label = 'Explain',
  autoSubmit = true,
  className = '',
  disabled = false,
}) {
  const { openWith } = useCopilotController();

  function handleClick() {
    const visual = typeof buildVisual === 'function' ? buildVisual() : visualProp;
    openWith({ question, visual: visual || null, autoSubmit });
  }

  return (
    <button
      type="button"
      className={`btn ghost sm explain-chart-btn${className ? ` ${className}` : ''}`}
      onClick={handleClick}
      disabled={disabled}
      aria-label={`Explain this chart with AI: ${question || label}`}
      title="Ask PRIME to explain this chart"
      data-testid="explain-chart-button"
    >
      <IconSparkles size={15} />
      <span>{label}</span>
    </button>
  );
}
